<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnFinancialActiveSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Financiele vaste activa')"
                         :calculated-value="data.calculated.balance_active_financial_financials"
                         v-model="data.edit.balance_active_financial_financials"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>